<template>
  <div>
    <div class="navbar-fixed">
      <nav>
        <div class="nav-wrapper blue">
          <div class="container">
            <router-link to="/" class="brand-logo left">
              <img id="imgid_logo" src="@/assets/logo.png" class="left" />
              <span></span>

              <span>{{user_display_name}}</span>
              <span v-if="user_display_name == 'MyLinkO'">
                <br />
                <span class="badge">.xyz</span>
              </span>
              <span  v-else>
                <br />
                <span class="badge">MyLinkO.xyz/{{linko_id}}</span>
              </span>
            </router-link>

            <!-- Dropdown Trigger -->
            <a class="dropdown-trigger btn right red" href="#" data-target="dropdown1">
              <i class="material-icons">dehaze</i>
            </a>

            <!-- Dropdown Structure -->
            <ul id="dropdown1" class="dropdown-content right">
              <li class="prifile_pic">
                <img
                  class="circle"
                  src="https://media-exp1.licdn.com/dms/image/C5603AQGouCLWPE5_tg/profile-displayphoto-shrink_200_200/0?e=1596672000&v=beta&t=Mt8YhHtJOOwxsX9MYtMS8oSL2QzqtFF7mTOug_RBUms"
                />
              </li>

              <li class="divider" tabindex="-1"></li>

              <li v-if="isLoggedIn">
                <a class="email white-text truncate">
                  <i class="material-icons">email</i>
                  {{currentUser}}
                </a>
              </li>
              <li v-if="isLoggedIn">
                <router-link to="/">
                  <i class="material-icons">view_module</i>Dashboard
                </router-link>
              </li>
              <li v-if="!isLoggedIn">
                <router-link to="/login">Login</router-link>
              </li>
              <li v-if="!isLoggedIn">
                <router-link to="/register">Register</router-link>
              </li>

              <li class="divider" tabindex="-1"></li>

              <li v-if="isLoggedIn" class="clslogout">
                <a>
                  <button @click="logout" class="btn red">Logout</button>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
export default {
  name: "navbar",
  data() {
    return {
      linko_id: "",
      isLoggedIn: false,
      currentUser: false,
      //curUserName : null,
      uid : "",
      userInfo: null,
    };
  },
  created() {
    //this.linko_id = this.$route.params.linko_id || ""; //replace with '' if undefined
    //console.log("linko_id :", this.linko_id);

    if (firebase.auth().currentUser) {
      //userInfo = firebase.auth().currentUser;
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
      this.uid = firebase.auth().currentUser.uid;
      //this.curUserName = firebase.auth().currentUser.getDisplayName();
      this.$store.state.is_logged_in = true;
    }
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.go({
            path: this.$router.path
          });
        });
    }
  },
  mounted: function() {
    $(".dropdown-trigger").dropdown();
    this.linko_id = this.$route.params.linko_id || '';
    this.$store.state.linko_id = this.linko_id;
    this.$store.state.loggedin_user_uid = this.uid;  
    console.log("Logged user's uid : "+this.uid); 
  },
  computed: {
    user_display_name:function(){
      return this.$store.state.profile_data.user_display_name || 'MyLinkO';
    }, 
  },
};
</script>

<style scoped>
.email {
  padding-right: 10px;
}

.brand-logo {
  font-family: "Quicksand", sans-serif;
  padding-left: 5px;
}
#imgid_logo
{
  height:45px;
  padding-right:5px;
}
.badge {
  margin-top: -5px;
  margin-left: -35px;
  letter-spacing: 2px;
  color: lightgray;
  font-size: 10px;
}

nav {
  line-height: 38px;
}
.nav-wrapper {
  padding-top: 10px;
}
#dropdown1 {
  width: 270px !important;
  border: solid 1px gray;
  background: darkslategray;
  display: float;
  position: fixed !important;
  top: 0px !important;
  left: auto !important;
  right: 1px !important;
  z-index: 100;
  height: 100%;
  opacity: 0.5;
}
.dropdown-trigger i {
  line-height: 40px !important;
}

.prifile_pic,
.clslogout {
  padding: 25px;
  padding-left: 75px;
  width: 100%;
}
.prifile_pic img {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue